import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { Payment } from "../models/payment";
import { PaymentService } from "../services/payment.service";

@Injectable()
export class PaymentByInvoiceResolver implements Resolve<Payment> {
  constructor(private service: PaymentService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Payment> {
    const id = Number(route.paramMap.get("id"));

    if (id != 0) {
      return this.service.getPaymentsByInvoiceId(+id);
    } else {
      return null;
    }
  }
}
